import { Injectable } from "@angular/core";
import { ApiService } from "./api.service";
import { AppConfig } from "../Utilities/app-config.service";

@Injectable({
  providedIn: "root",
})
export class AgentSkillService {
  constructor(private apiService: ApiService, private appConfig: AppConfig) {}

  getSkill() {
    return this.apiService.get(this.appConfig.GetUrl("getSkill"));
  }

  getSkillList() {
    return this.apiService.get(this.appConfig.GetUrl("getSkillList"));
  }

  deleteSkill(id: number) {
    return this.apiService.delete(
      this.appConfig.GetUrl("deleteSkill").replace("[SKILLID]", id)
    );
  }

  addSkill(skil: any) {
    return this.apiService.post(this.appConfig.GetUrl("addSkill"), skil);
  }

  getAgentEndorseSkills(agentId) {
    return this.apiService.get(
      this.appConfig
        .GetUrl("getAgentEndorseSkills")
        .replace("[AGENTID]", agentId)
    );
  }

  postAgentEndorseSkills(skill) {
    return this.apiService.post(this.appConfig.GetUrl("postAgentEndorseSkills"), skill);
  }

  deleteAgentEndorsedSkill(id: number) {
    return this.apiService.delete(
      this.appConfig.GetUrl("deleteAgentEndorseSkill").replace("[ID]", id)
    );
  }
}
